<template>
  <div class="table_container">
    <common-layout>
      <div slot="header">
        <h3>在线直播</h3>
      </div>
      <div slot="container">
        <div class="handle-box">
          <el-button
            style="background: #623aa2; border: none"
            type="success"
            size="medium"
            icon="el-icon-plus"
            class="handle-del mr10"
            @click="addNews()"
            >新增推流</el-button
          >
          <el-button
            type="danger"
            size="medium"
            icon="el-icon-delete"
            class="handle-del mr10"
            @click="deleteAll()"
            >批量删除</el-button
          >
          <el-input
            style="width: 30%; margin: 0 10px"
            placeholder="视频关键词"
            v-model="title_keyWord"
            clearable
            @clear="search"
            class="input-with-select"
            @keyup.enter.native="search"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
        </div>

        <div id="table">
          <!--动态绑定长宽-->
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            type="index"
            @select="tabSelect"
            @select-all="tabSelect"
            :header-cell-style="headerStyle"
          >
            <el-table-column type="selection"></el-table-column>
            <el-table-column
              prop="title"
              label="推流标题"
              align="center"
            ></el-table-column>
            <el-table-column prop="content" label="推流简介" align="center">
              <template slot-scope="scope">
                <p>{{ replaceNum(scope.row.content, 2) }}</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="isInvalid"
              label="是否失效"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="startTime"
              label="开始时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="endTime"
              label="结束时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="createTime"
              label="创建时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="isAnnounce1"
              label="是否预告"
              align="center"
            ></el-table-column>
            <el-table-column label="操作" align="center" width="380">
              <template slot-scope="scope">
                <el-button-group>
                  <el-button size="mini" @click="handleEdit(scope.row)"
                    >编辑</el-button
                  >
                  <el-button size="mini" type="success" @click="look(scope.row)"
                    >查看地址</el-button
                  >
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.row)"
                    >删除</el-button
                  >
                  <el-button
                    type="info"
                    size="mini"
                    @click="preview(scope.row)"
                    v-if="scope.row.isAnnounce == 2"
                    >显示预告</el-button
                  >
                  <el-button
                    size="mini"
                    type="warning"
                    @click="preview(scope.row)"
                    v-else
                    >取消预告</el-button
                  >
                  <el-button
                    size="mini"
                    type="success"
                    @click="onLine(scope.row)"
                    >在线时长</el-button
                  >
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- -------------------------------------------------- 分页 ----------------------------------------------------------------- -->
        <div class="pagination">
          <div class="grid-content bg-purple-light">
            <el-pagination
              @current-change="handleCurrentChange"
              layout="total, prev, pager, next,jumper"
              :total="total"
              :current-page.sync="current_page"
              :page-size="per_page"
            ></el-pagination>
          </div>
        </div>
      </div>
    </common-layout>
    <!-- ---------------------------- 编辑单条记录弹出框 ---------------------------------------------------------- -->
    <el-dialog
      :title="addOrEdit"
      :visible.sync="dialogFormVisible"
      label-position="center"
      :close-on-click-modal="false"
      @closed="is_submit = true"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
        class="demo-ruleForm"
      >
        <el-form-item label="id" prop="id" v-show="false">
          <el-input v-model="ruleForm.id"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="24">
            <el-form-item label="直播类型" prop="liveType">
              <el-select
                v-model="ruleForm.liveType"
                placeholder="请选择直播类型"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="标题" prop="title">
                <el-input v-model="ruleForm.title"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="appName" prop="appName">
                <el-input
                  v-model="ruleForm.appName"
                  :disabled="isEdit"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="stream" prop="streamName">
                <el-input
                  v-model="ruleForm.streamName"
                  :disabled="isEdit"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="类型" prop="pushType">
                <!-- <el-select v-model="ruleForm.pushType" placeholder="请选择类型" style="width:100%" :disabled="isEdit"> -->
                <el-select
                  v-model="ruleForm.pushType"
                  placeholder="请选择类型"
                  style="width: 100%"
                  disabled
                >
                  <el-option label="边缘推流" value="1"></el-option>
                  <el-option label="中心推流" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="开始时间" prop="startTime">
              <!-- <el-col :span="11"> -->
              <el-date-picker
                type="datetime"
                :picker-options="pickerOptions"
                placeholder="选择开始日期"
                v-model="ruleForm.startTime"
                style="width: 100%"
                :disabled="isEdit"
              ></el-date-picker>
              <!-- </el-col> -->
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="结束时间" prop="endTime">
              <!-- <el-col :span="1"> -->
              <el-date-picker
                type="datetime"
                :picker-options="pickerOptions"
                placeholder="选择结束日期"
                v-model="ruleForm.endTime"
                style="width: 100%"
                :disabled="isEdit"
              ></el-date-picker>
              <!-- </el-col> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="失效时间" prop="expireTime">
              <el-date-picker
                type="datetime"
                :picker-options="pickerOptions"
                placeholder="选择失效日期"
                v-model="ruleForm.expireTime"
                style="width: 100%"
                :disabled="isEdit"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间" prop="createTime">
              <el-input
                :disabled="true"
                v-model="ruleForm.createTime"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="封面" prop="image">
              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                name="file"
                :show-file-list="false"
                :on-success="handlePictureCardPreview"
                :before-upload="beforeAvatarUpload"
                :http-request="HouImgFile"
              >
                <img v-if="image" :src="imgUrl + image" class="img_border" />
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  :class="{ is_border: !image }"
                ></i>
                <span class="upload_btn" v-if="!image">上传图片</span>
                <span v-else class="upload_btn">更换图片</span>
              </el-upload>
              <span class="del_img" v-show="image">
                <i class="el-icon-error" @click="deleteImg"></i>
              </span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item label="简介" prop="content">
            <!-- <editor :quillData="ruleForm.content" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData"></editor> -->
            <editor
              v-model="ruleForm.content"
              :upload-url="uploadURL"
              :img-show-url="imgUrl"
            ></editor>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="12" style="padding-left: 75px">
            是否预告:
            <el-switch
              v-model="ruleForm.isAnnounce"
              on-color="#13ce66"
              off-color="#ff4949"
              on-text="是"
              off-text="否"
              :active-value="1"
              :inactive-value="2"
            ></el-switch>
          </el-col>
          <el-col :span="12" style="text-align: right">
            <el-button type="primary" @click="submitForm('ruleForm')"
              >确认</el-button
            >
            <el-button @click="resetForm('ruleForm')">取消</el-button>
          </el-col>
        </el-row>

        <!-- <el-form-item>
	    <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
	    <el-button @click="resetForm('ruleForm')">取消</el-button>
        </el-form-item>-->
      </el-form>
    </el-dialog>
    <!-- ********************************************************************************************* -->

    <el-dialog
      :title="addOrEdit"
      :visible.sync="dialogFormVisible1"
      label-position="center"
      :close-on-click-modal="false"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="75px"
        class="demo-ruleForm"
      >
        <el-form-item label="id" prop="id" v-show="false">
          <el-input v-model="ruleForm.id"></el-input>
        </el-form-item>

        <el-row>
          <el-col>
            <el-form-item label="推流地址">
              <el-input v-model="ruleForm.adress"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-form-item> -->
        <!-- <el-button type="primary" @click="close()">确认</el-button> -->
        <!-- </el-form-item> -->
      </el-form>
    </el-dialog>

    <el-dialog
      title="在线时长"
      :visible.sync="centerDialogVisibleOnLine"
      width="70%"
      center
    >
      <Table
        :table="table"
        :url="url"
        @editEvent="editEvent"
        ref="children"
      ></Table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisibleOnLine = false"
          >退 出</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import editor from "../../components/yhQuillEditor";
import editor from "../../components/tinymce-editor/tinymce-editor";
import CommonLayout from "../../components/common-layout.vue";
import Table from "../transfer/business/table";
import { CheckTimeLine, DisabledDateFn,DisabledDateFn1 } from "../../utils/tool";
export default {
  components: {
    editor,
    Table,
    CommonLayout,
  },
  data() {
    var Verification = (rule, value, callback) => {
      if (!/^[0-9a-zA-Z_]*$/g.test(value)) {
        callback(new Error("只能输入字母、数字、下划线"));
      } else if (value == "") {
        callback(new Error("请填写内容"));
      } else {
        callback();
      }
    };
    return {
      pickerOptions: {
        disabledDate: this.disabledDateFn,
      },
      is_submit: true,
      centerDialogVisibleOnLine: false,
      baseUrl: "/live/admin/live_vrecord?liveType=",
      url: "",

      table: {
        columns: [
          {
            prop: "title",
            label: "直播标题",
          },
          {
            prop: "name",
            label: "账号",
          },

          {
            prop: "viewDuration",
            label: "时长",
            type: "view_duration",
          },
        ],
        hasBtn: false,
        hasSelect: false,
        // btns: [
        //   {
        //     name: "编辑",
        //     event: "editEvent",
        //     type: "success"
        //   }
        // ]
      },
      headerStyle: {
        color: "#623AA2",
        background: "#E5F3FE",
      },
      isEdit: false,
      image: "",
      // isAnnounce: 'true',
      activeName: "1", //tab选项
      tableData: [], //列表数据
      title_keyWord: "",
      selected: [], //已选行数
      total: 10, //总页数
      current_page: 1, //当前页
      per_page: 20,
      columns: [
        ["id", "推流地址id"],
        // ["uid", "添加者id"],
        ["title", "推流标题"],
        ["content", "推流简介"],
        ["isInvalid", "是否失效"],
        ["startTime", "开始时间"],
        ["endTime", "结束时间"],
        ["createTime", "创建时间"],
        ["isAnnounce1", "是否预告"],
        // ["album", "视频封面"],
      ], //要显示的列名和接口key
      checked: false, //全选框
      checkList: [], //每行单选
      //编辑弹出表单
      ruleForm: {
        isAnnounce: 2,
        pushType: 1,
        createTime: "",
        endTime: "",
        expireTime: "",
        startTime: "",
        content: "",
        liveType: "",
      },
      options: [
        {
          value: "2",
          label: "技术经理人培训",
        },
        {
          value: "3",
          label: "专项推介活动",
        },
        {
          value: "4",
          label: "其他",
        },
      ],
      addOrEdit: "新增",
      // content: "", //编辑的文本内容
      // isHot: false, //是否推荐
      // switchWidth: 75, //是否选择框宽度
      dialogFormVisible: false,
      dialogFormVisible1: false,
      //表单验证规则
      rules: {
        title: [
          {
            required: true,
            message: "标题不能为空",
            trigger: "blur",
          },
        ],
        appName: [
          {
            required: true,
            trigger: "blur",
            validator: Verification,
          },
        ],
        streamName: [
          {
            required: true,
            trigger: "blur",
            validator: Verification,
          },
        ],
        pushType: [
          {
            required: true,
            message: "pushType不能为空",
            trigger: "blur",
          },
        ],
        expireTime: [
          {
            required: true,
            message: "请选择失效时间",
            trigger: "change",
          },
        ],
        startTime: [
          {
            required: true,
            message: "请选择开始时间",
            trigger: "change",
          },
        ],

        endTime: [
          {
            required: true,
            message: "请选择结束时间",
            trigger: "change",
          },
        ],
        liveType: [
          {
            required: true,
            message: "直播类型不能为空",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    let this_ = this;
    this_.getData();
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  methods: {
    //禁用日期选择
    disabledDateFn(time) {
      return DisabledDateFn1(time);
    },
    editEvent(row) {},
    submitOnLine() {
      this.centerDialogVisibleOnLine = false;
    },
    // 点击弹出在线时长
    onLine(row) {
      this.centerDialogVisibleOnLine = true;
      this.url = this.baseUrl + row.liveType + "&livePushUrlsId=" + row.id;
    },

    //tabs标签点击事件
    handleClick(type, event) {
      this.getData();
    },
    //富文本
    getQuillData(val) {
      this.ruleForm.content = val;
    },
    //获取列表数据
    getData(page = "") {
      let tmp = page ? this.current_page : 1;
      let params = {
        page: page ? this.current_page : 1,
        title: this.title_keyWord
      }

      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/live-push-urls/page`, params)
        .then((response) => {
          let newDate = new Date().getTime();
          this.tableData = response.data.data;
          this.total = response.data.total; //总页数
          this.per_page = response.data.per_page;
          this.current_page = response.data.current_page;
          for (var i in this.tableData) {
            this.tableData[i].id = this.tableData[i].id;
            this.tableData[i].startTime = this.pbcFun.formatDate(
              new Date(this.tableData[i].startTime * 1000),
              "yyyy-MM-dd hh:mm:ss"
            );
            this.tableData[i].endTime = this.pbcFun.formatDate(
              new Date(this.tableData[i].endTime * 1000),
              "yyyy-MM-dd hh:mm:ss"
            );
            this.tableData[i].createTime = this.pbcFun.formatDate(
              new Date(this.tableData[i].createTime * 1000),
              "yyyy-MM-dd hh:mm:ss"
            );
            this.tableData[i].isAnnounce1 = this.tableData[i].isAnnounce;
            this.tableData[i].isAnnounce1 =
              this.tableData[i].isAnnounce1 == 1 ? "是" : "否";
            this.tableData[i].isInvalid =
              this.tableData[i].expireTime * 1000 < newDate ? "是" : "否";
            this.tableData[i].content = this.tableData[i].content;
            this.tableData[i].liveType = this.tableData[i].liveType;
          }
        });
    },
    //搜索
    search() {
      this.current_page = 1;
      this.getData(true);
    },
    //新增
    addNews() {
      this.isEdit = false;
      this.addOrEdit = "新增";
      this.dialogFormVisible = true; //打开弹窗
      this.$nextTick(() => {
        this.$refs["ruleForm"].resetFields();
        this.ruleForm = {
          uid: 0, //添加者id
          title: "", //视频名
          content: "", //内容介绍
          liveType: "", //////直播类型
          pushType: "1", //类型
          appName: "",
          streamName: "",
          isAnnounce: 2,
          createTime: this.pbcFun.formatDate(
            new Date(new Date().getTime()),
            "yyyy-MM-dd hh:mm:ss"
          ), //创建时间 /*创建时间赋值为今天日期*/
          expireTime: "",
        };
        this.image = "";
      });
    },
    //预告
    preview(e) {
      let data = {};
      data.id = e.id;
      if (e.isAnnounce == 1) {
        data.isAnnounce = 2;
      } else if (e.isAnnounce == 2) {
        data.isAnnounce = 1;
      }
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/live-push-urls/update`, data).then((response) => {
        if (response.code == 0) {
          this.$message.success("设置成功！");
          this.getData();
        }
      });
    },
    //查看地址
    look(e) {
      this.addOrEdit = "查看";
      this.dialogFormVisible1 = true; //打开弹窗
      this.ruleForm.adress = e.pushUrl;
    },
    //关闭
    close() {
      this.dialogFormVisible1 = false; //打开弹窗
    },
    //编辑
    handleEdit(e) {
      this.isEdit = true;
      this.addOrEdit = "编辑";
      this.dialogFormVisible = true; //打开弹窗
      this.ruleForm = {
        id: "",
        title: "",
        content: "",
        liveType: "",
        appName: "",
        streamName: "",
        isAnnounce: "",
        pushType: "",
        createTime: "",
        startTime: "",
        endTime: "",
        expireTime: "",
      };
      this.$nextTick(() => {
        this.$refs["ruleForm"].resetFields();
        this.ruleForm.id = e.id;
        this.ruleForm.title = e.title;
        this.ruleForm.liveType = e.liveType;
        this.ruleForm.content = e.content;
        this.ruleForm.appName = e.appName;
        this.ruleForm.streamName = e.streamName;
        this.ruleForm.isAnnounce = e.isAnnounce;
        this.image = e.album;
        this.ruleForm.pushType = e.pushType.toString();

        this.ruleForm.createTime = e.createTime;

        this.ruleForm.startTime = new Date(e.startTime);

        this.ruleForm.endTime = new Date(e.endTime);
        this.ruleForm.expireTime = new Date(e.expireTime * 1000);

        // this.ruleForm.expireTime = this.pbcFun.formatDate(
        //   new Date(e.expireTime * 1000),
        //   "yyyy-MM-dd"
        // );
      });
    },
    //上传图片
    HouImgFile(e) {
      var files = e.file;
      if (!files) return;
      this.createImage(files, e, "HouImg");
    },
    //其他图片上传
    createImage(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960,
      })
        .then((rst) => {
          this.http
            .post("/file/base64_upload", { image: rst.base64 })
            .then((res) => {
              this.image = res.data;
            });
          return rst;
        })
        .always(() => {
          // 清空文件上传控件的值
          e.target.value = null;
        });
    },

    handlePictureCardPreview(file) {
      this.image = file.data.store_result;
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif" ||
        file.type === "image/bmp"
      ) {
        type = true;
      }

      var img = new Image();
      img.src = this.image;
      img.onload = function () {};

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return type && isLt2M;
    },
    deleteImg() {
      this.$confirm("确定删除图片吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.image = "";
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //提交编辑
    submitForm(formName) {
      console.log("是都允许", this.is_submit);
      if (!this.is_submit) {
        return;
      }
      this.is_submit = false;

      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 时间顺序校验
          let timeFlag = CheckTimeLine(
            this.ruleForm.startTime,
            this.ruleForm.endTime,
            this.ruleForm.expireTime
          );

          if (timeFlag) {
            this.is_submit = true;
            return;
          }
          let data = {
            album: typeof this.image == "undefined" ? "" : this.image, //视频封面
            // uid: this.pbcFun.getLocal("uid").id, //添加者id
            title: this.ruleForm.title, //视频名
            content:
              typeof this.ruleForm.content == "undefined"
                ? ""
                : this.ruleForm.content, //点播内容介绍
            liveType:
              typeof this.ruleForm.liveType == "undefined"
                ? ""
                : this.ruleForm.liveType, //点播内容介绍
            createTime: Math.floor(
              new Date(this.ruleForm.createTime).getTime() / 1000
            ), //创建时间
            endTime: Math.floor(
              new Date(this.ruleForm.endTime).getTime() / 1000
            ), //结束时间
            startTime: Math.floor(
              new Date(this.ruleForm.startTime).getTime() / 1000
            ), //开始时间
            expireTime: Math.floor(
              new Date(this.ruleForm.expireTime).getTime() / 1000
            ), //失效时间
            appName: this.ruleForm.appName,
            streamName: this.ruleForm.streamName,
            isAnnounce: this.ruleForm.isAnnounce,
            pushType: Number(this.ruleForm.pushType),
          };
          if (typeof this.ruleForm.id == "undefined") {
            //新增账户
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/trade/live-push-urls/create`, data)
              .then((response) => {
                if (response.code == 0) {
                  this.$message.success("添加成功！");
                  this.dialogFormVisible = false; //打开弹窗
                  this.getData();
                }
              });
          } else {
            //编辑账户
            let datab = {};
            datab.id = this.ruleForm.id;
            datab.title = data.title;
            datab.content = data.content;
            datab.liveType = data.liveType;
            datab.isAnnounce = data.isAnnounce;
            datab.album = data.album;
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/trade/live-push-urls/update`, datab)
              .then((response) => {
                if (response.code == 0) {
                  this.$message.success("编辑成功！");
                  this.dialogFormVisible = false; //打开弹窗
                  this.getData();
                }
              });
          }
        } else {
          this.is_submit = true;
        }
      });
    },
    //关闭编辑
    resetForm(formName) {
      this.dialogFormVisible = false;
    },
    //删除
    handleDelete(e) {
      this.$confirm("确定删除文件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.http.delete(`${urlConfig.devUrl}apij2/admin-api/trade/live-push-urls/delete?id=` + e.id).then(
            (response) => {
              if (response.code == 0) {
                this.$message.success("删除成功！");
                this.getData();
              }else{
                this.$message.error(response.status);
              }
            },
            (error) => {}
          );
          /*this.$message({
            type: "success",
            message: "删除成功!",
          });*/
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //批量删除
    deleteAll() {
      this.$confirm("确定删除文件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.http
            .delete(`${urlConfig.devUrl}apij2/admin-api/trade/live-push-urls/batchDelete?ids=` + this.selected)
            .then((response) => {
              if (response.code == 0) {
                this.$message.success("删除成功！");
                this.current_page = 1;
                this.getData();
              }else{
                this.$message.error(response.status);
              }
            });
          /*this.$message({
            type: "success",
            message: "删除成功!",
          });*/
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //选择行数
    tabSelect(sec, row) {
      let ids = "";
      for (let i of sec) {
        ids += i.id + ",";
      }
      ids = ids.substr(0, ids.length - 1);
      this.selected = ids;
    },
    //替换数字为中文
    replaceNum(data, index) {
      //去掉html标签
      if (index == 2 && data) {
        data = data || "";
        data = this.GetTarg(data);
      }
      //创建时间
      if (data) {
        if (index == 4 || index == 5 || index == 6) {
          if (data.toString().length < 11)
            data = this.pbcFun.formatDate(
              new Date(Number(data) * 1000),
              "yyyy-MM-dd hh:mm:ss"
            );
          else if (data.toString().length == 13)
            data = this.pbcFun.formatDate(
              new Date(Number(data)),
              "yyyy-MM-dd hh:mm:ss"
            );
        }
      }
      return data;
    },
    //选择页码
    handleCurrentChange(e) {
      this.current_page = e;
      this.getData(true);
    },
    onEditorReady(editor) {
      //        console.log('editor ready!', editor);
    },
  },
};
</script>
<style lang="scss" scoped>
* {
  word-break: normal;
}

.table_container {
  text-align: left;
  height: 100%;

  .handle-box {
    .handle-input {
      /deep/ .el-input__suffix {
        margin-right: 10px;
      }
    }
  }

  #table {
    margin-top: 20px;
    border: 1px solid #eef1f6;

    /deep/ th {
      // background-color: #eef1f6 !important;
      // color: #000;
    }

    /deep/ td {
    }

    /deep/ .cell {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    p {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .pagination {
    margin-top: 10px;
  }

  //文本编辑器
  .quill-editor {
    height: 400px;

    /deep/ .ql-container {
      height: calc(100% - 80px) !important;
    }
  }

  .editer {
    padding: 10px 0;
  }

  /*上传图片*/
  .is_border {
    border: 1px dashed #ddd !important;
    border-radius: 5px;
    height: 154px !important;
    line-height: 154px !important;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }

  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }

  .avatar-uploader {
    text-align: center;
    width: 243px;
    height: 178px;
  }

  /deep/ .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 243px;
    height: 154px;
    line-height: 154px;
    text-align: center;
  }

  /deep/ .el-dialog__header {
    text-align: center !important;
  }
}
.demo-ruleForm .el-select {
  width: 100% !important;
}
</style>
